import { Inject, Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';
import { APP_SETTINGS, AppSettings } from '../settings';

@Injectable({
  providedIn: 'root',
})
export class EncryptionService {
  constructor(@Inject(APP_SETTINGS) private settings: AppSettings) {}

  private readonly SALT = CryptoJS.enc.Base64.parse('SXZhbiBNZWR2ZWRldg==');
  private readonly ITERATIONS = 1000;

  private readonly KEY = '8BoCKkAKS8BMd0Y32p03hB6W7GrR5cd8sBMmCMjbMT4=';
  private readonly IV = 'PmcsgkpeHk/BT5c2cdeLcP==';
  private readonly BLOCK_SIZE = 128;

  //   encryptUsingAES256(inputData) {
  //     const keyvalue = environment.keyValue;
  //     const ivValue = environment.ivValue;

  //     const _key = CryptoJS.enc.Hex.parse(keyvalue);
  //     const _iv = CryptoJS.enc.Hex.parse(ivValue);

  //     const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(inputData), _key, {
  //         keySize: 128 / 8,
  //         iv: _iv,
  //         mode: CryptoJS.mode.CBC,
  //         padding: CryptoJS.pad.Pkcs7
  //     });
  //     const encryptedOP = CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
  //     return encryptedOP;
  // }

  encryptUsingAES_256(input) {
    try {
      // let _key = CryptoJS.enc.Hex.parse(this.settings.keyValue);
      // let _iv = CryptoJS.enc.Hex.parse(this.settings.ivValue);
      let _key = CryptoJS.enc.Hex.parse(
        '842a357c4b385726090aa184b75b691075da95e6ddd4eb40'
      );
      let _iv = CryptoJS.enc.Hex.parse('53471a3a3623160b53471a3a3623160b');

      console.log('key', _iv);
      
      let encrypted = CryptoJS.AES.encrypt(
        CryptoJS.enc.Utf8.parse(input),
        _key,
        {
          keySize: 128 / 8,
          iv: _iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        }
      );
      const encryptedData = CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
      return encryptedData;
    } catch (e) {
      console.log('Error in encryption - ', e);
    }
  }

  decryptUsingAES_256(input) {
    try {
      if (input != null || input != undefined) {
        let _key = CryptoJS.enc.Hex.parse(
          '842a357c4b385726090aa184b75b691075da95e6ddd4eb40'
        );
        let _iv = CryptoJS.enc.Hex.parse('53471a3a3623160b53471a3a3623160b');

        const decrypted = CryptoJS.AES.decrypt(input, _key, {
          keySize: 128 / 8,
          iv: _iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        }).toString(CryptoJS.enc.Utf8);

        return decrypted.replace(/^"|"$/g, '');
      }
    } catch (e) {
      console.log('Error in decryption - ', e);
    }
  }

  encryptAttachment(input: string): string | null {
    try {

      
      
      const keyBytes = CryptoJS.enc.Base64.parse(this.KEY);
      const ivBytes = CryptoJS.enc.Base64.parse(this.IV);

      const encrypted = CryptoJS.AES.encrypt(
        input, 
        keyBytes, 
        {
          iv: ivBytes,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
          keySize: this.BLOCK_SIZE
        }
      );

      // Step 3: Return the final encrypted string in Base64 format
      console.log('encrypted', encrypted.toString());
      
      return encrypted.toString();

    } catch (error) {
      console.error('Encryption failed:', error);
      return null;
    }
  }
}
